import React, { useState } from "react";
import "./SupportRequest.css";
import "../../components/UploadDocument/UploadDocument.css";
import BackButton from "../../components/BackButton/BackButton";
import { cloud_upload } from "../../assets/images/images";
import { toast } from "react-toastify";
import api from "../../api/api";
import { useAuth } from "../../features/auth/AuthContext";
import file_img_storage from "../../assets/images/file-storage.png";
import png_svg from "../../assets/images/png-svg.svg";
import jpg_svg from "../../assets/images/jpg-svg.svg";
import pdf_svg from "../../assets/images/pdf-svg.svg";
import FilePreviewModal from "../../components/UploadDocument/FilePreviewModal";
// import * as pdfjsLib from "pdfjs-dist";
import SuccessScreen from "./SuccessScreen";
import { useNavigate, useSearchParams } from "react-router";

// pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

const SupportRequest = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const from = searchParams.get("from"); // "mycourse"
  const { token } = useAuth();
  const [formData, setFormData] = useState({
    inquiry_description: "",
  });

  const [files, setFiles] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [isRemovingFile, setIsRemovingFile] = useState(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [currentPreviewIndex, setCurrentPreviewIndex] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);


  // FILE VALIDATION CONSTANTS
  const ALLOWED_FILE_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "application/pdf",
  ];
  const ALLOWED_EXTENSIONS = [".jpg", ".jpeg", ".png", ".pdf"];
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "inquiry_description" && value.length > 3000) {
      toast.warning("Inquiry cannot exceed 3000 characters!", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // VALIDATE FILE TYPE
  const isValidFileType = (file) => {
    const fileExtension =
      "." +
      file.name
        .split(".")
        .pop()
        .toLowerCase();
    return (
      ALLOWED_FILE_TYPES.includes(file.type) &&
      ALLOWED_EXTENSIONS.includes(fileExtension)
    );
  };

  // FORMAT FILE SIZE FOR DISPLAY
  const formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
  };

// CHECK FILE CORRUPTION AND PAGE COUNT
const checkFileCorruption = (file) => {
  return new Promise(async (resolve) => {
    try {
      // img files
      if (file.type.startsWith("image/")) {
        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = () => {
          URL.revokeObjectURL(objectUrl);
          resolve({ valid: true, file, pageCount: null });
        };

        img.onerror = () => {
          URL.revokeObjectURL(objectUrl);
          resolve({ valid: false, file, pageCount: null });
        };

        img.src = objectUrl;
        return;
      }

      // PDF files ---
      // if (
      //   file.type === "application/pdf" ||
      //   file.name.toLowerCase().endsWith(".pdf")
      // ) {
      //   try {
      //     const fileUrl = URL.createObjectURL(file);
      //     const loadingTask = pdfjsLib.getDocument(fileUrl);
      //     const pdf = await loadingTask.promise;
      //     const pageCount = pdf.numPages;
      //     URL.revokeObjectURL(fileUrl);
      //     resolve({ 
      //       valid: pageCount > 0, 
      //       file, 
      //       pageCount: pageCount 
      //     });
      //   } catch (err) {
      //     resolve({ valid: false, file, pageCount: null });
      //   }
      //   return;
      // }

      // PDF files — magic bytes + encryption + xref check (no pdfjsLib)
    if (
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf")
    ) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const bytes = new Uint8Array(e.target.result);

          // 1. Check PDF magic bytes: must start with %PDF-
          const isPDF =
            bytes[0] === 0x25 && // %
            bytes[1] === 0x50 && // P
            bytes[2] === 0x44 && // D
            bytes[3] === 0x46 && // F
            bytes[4] === 0x2D;   // -

          if (!isPDF) {
            resolve({ valid: false, file, pageCount: null });
            return;
          }

          // Decode as latin1 to safely handle binary PDF content
          const text = new TextDecoder("latin1").decode(bytes);

          // 2. Check for password encryption
          const isEncrypted =
            text.includes("/Encrypt") ||
            text.includes("/EncryptMetadata") ||
            text.includes("/StdCF");

          if (isEncrypted) {
            resolve({ valid: false, file, pageCount: null });
            return;
          }

          // 3. Check for valid xref table (basic structure integrity)
          const hasXref = text.includes("xref") || text.includes("startxref");
          if (!hasXref) {
            resolve({ valid: false, file, pageCount: null });
            return;
          }

          // 4. Count pages via /Type /Page (exclude /Type /Pages parent node)
          const pageMatches = text.match(/\/Type\s*\/Page[^s]/g);
          const pageCount = pageMatches ? pageMatches.length : 1;

          resolve({ valid: true, file, pageCount });
        } catch (err) {
          resolve({ valid: false, file, pageCount: null });
        }
      };
      reader.onerror = () => resolve({ valid: false, file, pageCount: null });
      reader.readAsArrayBuffer(file);
      return;
    }

      // Other files 
      const reader = new FileReader();
      reader.onload = () => resolve({ valid: true, file, pageCount: null });
      reader.onerror = () => resolve({ valid: false, file, pageCount: null });
      reader.readAsArrayBuffer(file);
    } catch (err) {
      resolve({ valid: false, file, pageCount: null });
    }
  });
};

// PROCESS AND VALIDATE FILES
const processFiles = async (selectedFiles) => {
  const filesArray = Array.from(selectedFiles);

  // Check file types
  const invalidTypeFiles = [];
  const validTypeFiles = filesArray.filter((file) => {
    const isValid = isValidFileType(file);
    if (!isValid) {
      invalidTypeFiles.push(file.name);
    }
    return isValid;
  });

  // Show error for invalid file types
  if (invalidTypeFiles.length > 0) {
  // Extract file extensions from file names
  const fileExtensions = invalidTypeFiles.map(fileName => 
    "." + fileName.split(".").pop().toLowerCase()
  ).join(", ");
  
  toast.error(
    `${fileExtensions} files cannot be uploaded.`,
    {
      position: "top-right",
      autoClose: 4000,
    },
  );
}

  if (validTypeFiles.length === 0) {
    return;
  }

  // Check file sizes
  const oversizedFiles = [];
  const validSizeFiles = validTypeFiles.filter((file) => {
    const isValidSize = file.size <= MAX_FILE_SIZE;
    if (!isValidSize) {
      oversizedFiles.push({ name: file.name, size: file.size });
    }
    return isValidSize;
  });

  // Show error for oversized files
  if (oversizedFiles.length > 0) {
    oversizedFiles.forEach((file) => {
      toast.error(
        `These file exceed the 5MB: ${file.name}`,
        {
          position: "top-right",
          autoClose: 4000,
        },
      );
    });
  }

  if (validSizeFiles.length === 0) {
    return;
  }

  //Check for corrupted files and get page counts
  const corruptionResults = await Promise.all(
    validSizeFiles.map((file) => checkFileCorruption(file)),
  );

  const corruptedFiles = corruptionResults
    .filter((r) => !r.valid)
    .map((r) => r.file);
  const validFiles = corruptionResults.filter((r) => r.valid);

  // Show error for corrupted files
  if (corruptedFiles.length > 0) {
    corruptedFiles.forEach((file) => {
      toast.error(
        `Your attached file "${file.name}" is corrupted.`,
        {
          position: "top-right",
          autoClose: 4000,
        },
      );
    });
  }

  if (validFiles.length === 0) {
    return;
  }

  // Check PDF page count (max 10 pages)
  const pdfExceedingPageLimit = [];
  const validPageCountFiles = validFiles.filter((result) => {
    if (result.pageCount !== null && result.pageCount > 10) {
      pdfExceedingPageLimit.push({
        name: result.file.name,
        pageCount: result.pageCount,
      });
      return false;
    }
    return true;
  });

  // Show error for PDFs exceeding page limit
  if (pdfExceedingPageLimit.length > 0) {
    pdfExceedingPageLimit.forEach(({ name, pageCount }) => {
      toast.error(
        `You can upload PDFs with up to 10 pages only.`,
        {
          position: "top-right",
          autoClose: 4000,
        },
      );
    });
  }

  if (validPageCountFiles.length === 0) {
    return;
  }

  // Create file objects with URLs
  const filesWithIds = validPageCountFiles.map((result) => ({
    id: Math.random()
      .toString(36)
      .substr(2, 9),
    file: result.file,
    name: result.file.name,
    size: result.file.size,
    type: result.file.type,
    url: URL.createObjectURL(result.file),
    isLoading: false,
    pageCount: result.pageCount, // Store page count for reference
  }));

  setFiles((prev) => [...prev, ...filesWithIds]);

  // Success message if files were added
  if (filesWithIds.length > 0) {
    toast.success(`${filesWithIds.length} files added successfully!`, {
      position: "top-right",
      autoClose: 2000,
    });
  }
};

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = async (e) => {
    e.preventDefault();
    setIsDragging(false);

    const droppedFiles = e.dataTransfer.files;
    await processFiles(droppedFiles);
  };

  const handleFileSelect = async (e) => {
    const selectedFiles = e.target.files;
    await processFiles(selectedFiles);
    e.target.value = "";
  };

  const removeFile = async (e, id) => {
    e.stopPropagation();

    if (isRemovingFile || isUploading) {
      toast.warning("Please wait, operation in progress...");
      return;
    }

    setIsRemovingFile(id);

    try {
      await new Promise((resolve) => setTimeout(resolve, 1000));

      const fileToRemove = files.find((f) => f.id === id);
      if (fileToRemove && fileToRemove.url) {
        URL.revokeObjectURL(fileToRemove.url);
      }

      setFiles((prev) => prev.filter((file) => file.id !== id));
      toast.success("File removed successfully!");
    } catch (error) {
      toast.error("Failed to remove file. Please try again.");
    } finally {
      setIsRemovingFile(null);
    }
  };

  const openPreview = (index) => {
    setCurrentPreviewIndex(index);
    setIsPreviewOpen(true);
  };

  const closePreview = () => {
    setIsPreviewOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.inquiry_description || formData.inquiry_description.trim() === "") {
      toast.error("Please fill in all required fields", {
        position: "top-right",
      });
      return;
    }

    setIsUploading(true);

    try {
      setFiles((prev) => prev.map((file) => ({ ...file, isLoading: true })));

      const formDataToSend = new FormData();
      formDataToSend.append("inquiry_description", formData.inquiry_description);

      // Handle attachments - send empty array if no files
   if (files.length > 0) {
      files.forEach((fileObj) => {
        formDataToSend.append("attachments", fileObj.file);
      });
    }
      const response = await api.post(
        "/common_utils/create-support-ticket/",
        formDataToSend,
        {
          headers: {
            Authorization: `Token ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Support request submitted successfully!", {
          position: "top-right",
        });

        files.forEach((file) => {
          if (file.url) {
            URL.revokeObjectURL(file.url);
          }
        });

        setFormData({ inquiry_description: "" });
        setFiles([]);

        setIsSubmitted(true);
      }
    } catch (error) {
      console.error("Submission error:", error);

      const errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to submit request. Please try again.";
      toast.error(errorMessage, {
        position: "top-right",
      });

      setFiles((prev) => prev.map((file) => ({ ...file, isLoading: false })));
    } finally {
      setIsUploading(false);
    }
  };
 const handleRaiseNewTicket = () => {
    setIsSubmitted(false);
    setFormData({ inquiry_description: "" });
    setFiles([]);
  };
  const handleBrowseClick = () => {
    document.getElementById("file-input").click();
  };

  // Helper functions
  const getFileIcon = (fileType, fileName) => {
    if (!fileType || typeof fileType !== "string") {
      return <FileStorageIcon />;
    }

    if (fileType.includes("png")) return <PngIcon />;
    if (fileType.includes("jpg") || fileType.includes("jpeg"))
      return <JpgIcon />;
    if (fileType.includes("pdf")) return <FilePdfIcon />;
    return <FileStorageIcon />;
  };

  // Icon Components
  const XIcon = () => (
    <svg
      style={{ width: "100%", height: "100%" }}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M6 18L18 6M6 6l12 12"
      />
    </svg>
  );

 const PngIcon = () => (
    <img src={png_svg} alt="PNG" style={{ width: '20px', height: '20px', }} />
  );

  const JpgIcon = () => (
    <img src={jpg_svg} alt="JPG" style={{ width: '20px', height: '20px', }} />
  );

  const FilePdfIcon = () => (
    <img src={pdf_svg} alt="PDF" style={{ width: '20px', height: '20px', }} />
  );

  const FileStorageIcon = () => (
    <img src={file_img_storage} alt="File Storage" style={{ width: '20px', height: '20px', }} />
  );  

  return (
     <div className="support-request-section">
      {/* <BackButton buttonName={"Back"} /> */}
      {/* {from === "mycourse" ? (
                  <div className="view-course-Details-back-btn-folder" onClick={() => 
                  navigate("/dashboard/my-courses")
                }>
                  <i

                    class="fa-solid fa-chevron-left"
                  ></i>
                  <h2>Back</h2>
                </div>
):(
                  <div className="view-course-Details-back-btn-folder">
                  <BackButton buttonName="Back" goBack={true} />
                </div>
)} */}
{from === "mycourse" ? (
  <div
    className="view-course-Details-back-btn-folder"
    onClick={() => navigate("/dashboard/my-courses")}
  >
    <i className="fa-solid fa-chevron-left"></i>
    <h2>Back</h2>
  </div>
) : from === "dashboard" ? (
  <div
    className="view-course-Details-back-btn-folder"
    onClick={() => navigate("/dashboard/home")}
  >
    <i className="fa-solid fa-chevron-left"></i>
    <h2>Back</h2>
  </div>
) : (
  <div className="view-course-Details-back-btn-folder">
    <BackButton buttonName="Back" goBack={true} />
  </div>
)}
      {isSubmitted ? (
          <SuccessScreen onRaiseNewTicket={handleRaiseNewTicket} />
      ): (
          <div className="support-request-wrapper">
        <form onSubmit={handleSubmit}>
          <h4>Support Request</h4>
          <p className="subtitle">
            Submit a support request and our team will help you as soon as
            possible.
          </p>

          <div className="form-group-section">
            <div className="form-group">
              <label htmlFor="inquiry_description">How can we help?</label>
              <textarea
                id="inquiry_description"
                name="inquiry_description"
                placeholder="Enter your Inquiry in detail"
                value={formData.inquiry_description}
                onChange={handleInputChange}
                rows="5"
                maxLength={3000}
                disabled={isUploading}
              />
                <span style={{fontSize: '10px'}}>
                        (Character limit: {formData.inquiry_description.length || 0}/3000)
                </span>
            </div>

            <div className="form-group">
              <label className="attachments">Attachments</label>
              <div
                className={`file-upload-area ${isDragging ? "dragging" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                style={{
                  opacity: isUploading ? 0.6 : 1,
                  pointerEvents: isUploading ? "none" : "auto",
                }}
              >
                <div className="upload-icon">
                  <img src={cloud_upload} alt="upload-img" />
                </div>
                <p className="upload-text">
                  Drag & drop files or{" "}
                  <span className="browse-link" onClick={handleBrowseClick}>
                    browse
                  </span>
                </p>
                <p className="file-types">
                  Supported file types: .jpg, .jpeg, .png, .pdf (Max 5MB each)
                </p>
              </div>
              <input
                type="file"
                id="file-input"
                multiple
                accept=".jpg,.jpeg,.png,.pdf"
                onChange={handleFileSelect}
                style={{ display: "none" }}
                disabled={isUploading}
              />

              {files.length > 0 && (
                <>
                  <div
                    className="uploaded-files-list"
                    style={{
                      fontSize: "12px",
                      color: "#000",
                      fontWeight: "600",
                      marginTop: "16px",
                    }}
                  >
                    Uploaded Files
                  </div>
                  <div className="uploaded-files-container">
                    {files.map((file, index) => (
                      <div
                        className="uploaded-file-item"
                        key={file.id}
                        title={file.name}
                        onClick={() =>
                          !isRemovingFile &&
                          !file.isLoading &&
                          openPreview(index)
                        }
                        style={{
                          opacity:
                            isRemovingFile === file.id || file.isLoading
                              ? 0.6
                              : 1,
                          pointerEvents:
                            isRemovingFile === file.id || file.isLoading
                              ? "none"
                              : "auto",
                          position: "relative",
                          cursor:
                            isRemovingFile === file.id || file.isLoading
                              ? "default"
                              : "pointer",
                        }}
                      >
                        <div
                          className="uploaded-file-icon"
                          style={{ borderRadius: "50%" }}
                        >
                          {getFileIcon(file.type, file.name)}
                        </div>
                        <div className="uploaded-file-info">
                          <span
                            style={{
                              fontSize: "12px",
                              color: "#000",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "90px",
                              fontWeight: "400",
                            }}
                          >
                            {file.name}
                          </span>
                          <div
                            style={{
                              fontSize: "10px",
                              color: "#666",
                              display: "inline-block",
                            }}
                          >
                            {formatFileSize(file.size)}
                          </div>
                        </div>

                        {isRemovingFile === file.id || file.isLoading ? (
                          <div
                            style={{
                              marginLeft: "auto",
                              flexShrink: 0,
                              width: "21px",
                              height: "21px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div className="file-loader"></div>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={(e) => removeFile(e, file.id)}
                            disabled={isRemovingFile !== null || isUploading}
                            style={{
                              background: "none",
                              border: "none",
                              padding: "2px",
                              cursor:
                                isRemovingFile !== null || isUploading
                                  ? "not-allowed"
                                  : "pointer",
                              color: "#000",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "3px",
                              marginLeft: "auto",
                              flexShrink: 0,
                              width: "21px",
                              height: "21px",
                              opacity:
                                isRemovingFile !== null || isUploading
                                  ? 0.5
                                  : 1,
                            }}
                            aria-label="Remove file"
                          >
                            <XIcon />
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isUploading}
            style={{
              opacity: isUploading ? 0.6 : 1,
              cursor: isUploading ? "not-allowed" : "pointer",
            }}
          >
            {isUploading ? "Submitting..." : "Submit"}
          </button>
        </form>
          </div>
      )}
      
      {isPreviewOpen && (
        <FilePreviewModal
          isOpen={isPreviewOpen}
          files={files}
          initialIndex={currentPreviewIndex}
          onClose={closePreview}
          getFileIcon={getFileIcon}
        />
      )}
    </div>
  );
};

export default SupportRequest;
